import { useState, useRef, useEffect } from "react";
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import DeviceService from "../../Services/DeviceService";
import { ReactComponent as Save } from '../../Assets/img/Edit-icon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import "bootstrap/dist/css/bootstrap.min.css";

/**
 * Renders edit device model pop up to edit device model
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 * @param {Event} props.deviceModelId to unique identifier of device models
 */
function EditDeviceModel(props) {

    //#region States

    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);
    const [deviceModel, setDeviceModel] = useState({});

    //#endregion

    //#region Refs

    const modelInputRef = useRef();
    const makeInputRef = useRef();

    //#endregion

    //#region useEffect hook

    /**
    * Calls device service to fetch device models
    * Runs on first render
   */

    useEffect(() => {
        DeviceService.GetDeviceModel(props.deviceModelId).then((deviceModel) => {
            setDeviceModel(deviceModel.response);
        })
    }, [])

    //#endregion

    function resetHandler() {
        setError("");
        setMessagePopup(false);
    }

    //#region Handle Submit

    /**
    * Calls device service to edit device model
    * @param  {Event} event  User action (on submitting form)
    */

    function handleSubmit(event) {
        event.preventDefault();

        let DeviceModelDTO = {
            Make: ((makeInputRef.current.value === "") ? null : makeInputRef.current.value),
            Model: ((modelInputRef.current.value === "") ? null : modelInputRef.current.value),
        };

        DeviceService.UpdateDeviceModel(props.deviceModelId, DeviceModelDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                }
                else {
                    props.onClose();
                    props.onShowMessage("Device Model updated Sucessfully");
                }
            })
            .catch((err) => {
                setError(err.response?.data?.errors?.[0]?.message || "Unable to update device model.");
                setMessagePopup(true);
            });
    }

    //#endregion

    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>
            <ModalHeader className="AddDeviceHeader" style={{ border: "none" }} closeButton>
                <ModalTitle className="Header"><strong>Edit Device Model</strong></ModalTitle>
            </ModalHeader>
            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={handleSubmit}>
                    <div style={{ padding: '3%' }}>
                        <div>
                            <label for="Model" className="label">Model</label>
                            <div>
                                <input type="text" className="InputField" ref={modelInputRef} defaultValue={deviceModel.Model} required />
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="Make" className="label">Make</label>
                            <div>
                                <input type="text" className="InputField" ref={makeInputRef} defaultValue={deviceModel.Make} required />
                            </div>
                        </div>
                    </div>

                    <ModalFooter className="AddDeviceFooter" style={{ border: "none" }}>
                        <div>
                            <button type="reset" className="secondary-button" onClick={resetHandler}>
                                <span className="secondary-button-icon"><ResetIcon /></span>
                                <span className="secondary-button-text">Reset</span>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button ">
                                <span className="primary-button-icon"><Save /></span>
                                <span className="primary-button-text">Edit</span>
                            </button>
                        </div>
                    </ModalFooter>
                </form>
            </Modal.Body>

        </Modal >
    );
}
export default EditDeviceModel;
